import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';
import { UseFormWatch } from 'react-hook-form';

type FormValues = {
  offerId: string;
};

export function useSelectedOffer(
  availableProducts: NonNullable<
    GetFormalOffersResponse['data']
  >['formal_offers'],
  watch: UseFormWatch<FormValues>,
) {
  const selectedOfferId = watch('offerId');

  return availableProducts.find((offer) => offer.offer_id === selectedOfferId);
}
